/********************************************************************
 * floating-widget.js
 *
 * Shows the site-wide floating widget and remembers a dismissal for
 * DISMISS_DAYS. Stores nothing but a timestamp — no tracking.
 */

const STORAGE_PREFIX = 'wstheme.floatingWidget.dismissedAt';
const DISMISS_DAYS = 7;
const DISMISS_MS = DISMISS_DAYS * 24 * 60 * 60 * 1000;

// The widget carries its record's uid+tstamp, so a re-saved campaign gets a
// fresh key and re-appears for visitors who dismissed the previous one.
function storageKey(widget) {
    return STORAGE_PREFIX + '.' + widget.dataset.floatingWidget;
}

function escapeRegExp(value) {
    return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

// LocalStorage throws in private mode and when disabled; fall back to a cookie.
function readDismissedAt(key) {
    try {
        const stored = window.localStorage.getItem(key);
        if (stored !== null) {
            return parseInt(stored, 10);
        }
    } catch (e) {
        // ignore
    }

    const match = document.cookie.match(new RegExp('(?:^|; )' + escapeRegExp(key) + '=(\\d+)'));

    return match ? parseInt(match[1], 10) : NaN;
}

function writeDismissedAt(key, timestamp) {
    try {
        window.localStorage.setItem(key, String(timestamp));
        return;
    } catch (e) {
        // ignore
    }

    document.cookie = key + '=' + timestamp
        + ';path=/;max-age=' + Math.floor(DISMISS_MS / 1000)
        + ';SameSite=Lax';
}

// A timestamp in the future — clock skew, a tampered value — would otherwise
// keep the widget hidden for as long as it takes real time to catch up.
function isDismissed(key) {
    const age = Date.now() - readDismissedAt(key);

    return age >= 0 && age < DISMISS_MS;
}

function initFloatingWidget(widget) {
    const key = storageKey(widget);

    if (isDismissed(key)) {
        return;
    }

    const dismiss = () => {
        writeDismissedAt(key, Date.now());
        widget.hidden = true;
    };

    const closeButton = widget.querySelector('[data-floating-widget-close]');
    if (closeButton) {
        closeButton.addEventListener('click', dismiss);
    }

    // Dismiss on CTA click too, but let the link navigate.
    const cta = widget.querySelector('[data-floating-widget-cta]');
    if (cta) {
        cta.addEventListener('click', () => writeDismissedAt(key, Date.now()));
    }

    widget.hidden = false;
}

document.addEventListener('DOMContentLoaded', () => {
    const widget = document.querySelector('[data-floating-widget]');
    if (widget) {
        initFloatingWidget(widget);
    }
});
